// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","StrollerBoxWidget":"beo_a bhl_tp","StrollerBoxWidget__imageCounselling":"beo_b bhl_ke"};